import { PAYMENT_METHOD_NAMES, type PaymentMethodName } from '../types/spark-options';
import { type DropReporter, normalizeOrder } from './order';

export function normalizePaymentMethodsOrder(
  values: readonly unknown[],
  onDrop?: DropReporter,
): PaymentMethodName[] {
  return normalizeOrder(values, PAYMENT_METHOD_NAMES, onDrop);
}
